import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const dotsVerticalTestId = 'dots-vertical-test-id';

export const DotsVerticalIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox={`0 0 24 24`}
            data-testid={dotsVerticalTestId}
        >
            <g className={fillStyle}>
                <path d="M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0zM10 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0zM10 19a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
            </g>
        </svg>
    );
};

DotsVerticalIcon.TEST_ID = dotsVerticalTestId;
